(function () {
    var CACHE_KEY = 'casper-dev-search-v1';
    var CACHE_TTL = 1000 * 60 * 15;
    var posts = null;
    var fuse = null;
    var isLoading = false;

    function getApiKey() {
        return document.body.getAttribute('data-content-api-key') || '';
    }

    function getApiBase() {
        var url = document.body.getAttribute('data-ghost-api-url') || window.location.origin;
        return url.replace(/\/$/, '');
    }

    function getModal() {
        return document.getElementById('dev-search');
    }

    function getInput() {
        return document.getElementById('dev-search-input');
    }

    function getResultsEl() {
        return document.querySelector('[data-search-results]');
    }

    function getStatusEl() {
        return document.querySelector('[data-search-status]');
    }

    function setStatus(message) {
        var el = getStatusEl();
        if (el) {
            el.textContent = message || '';
        }
    }

    function extractPlaintext(html) {
        var container = document.createElement('div');
        container.innerHTML = html || '';
        return container.textContent.replace(/\s+/g, ' ').trim();
    }

    function extractCodeText(html) {
        var container = document.createElement('div');
        container.innerHTML = html || '';
        var chunks = [];

        container.querySelectorAll('pre code, pre, .kg-code-card code').forEach(function (node) {
            var text = node.textContent.replace(/\s+/g, ' ').trim();
            if (text) {
                chunks.push(text);
            }
        });

        return chunks.join('\n');
    }

    function normalizePost(post) {
        return {
            title: post.title || '',
            url: post.url || ('/' + post.slug + '/'),
            excerpt: post.custom_excerpt || post.excerpt || '',
            plaintext: extractPlaintext(post.html),
            code: extractCodeText(post.html)
        };
    }

    function readCache() {
        try {
            var raw = sessionStorage.getItem(CACHE_KEY);
            if (!raw) {
                return null;
            }

            var parsed = JSON.parse(raw);

            if (Date.now() - parsed.time > CACHE_TTL) {
                return null;
            }

            return parsed.posts;
        } catch (err) {
            return null;
        }
    }

    function writeCache(items) {
        try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({
                time: Date.now(),
                posts: items
            }));
        } catch (err) {
            /* ignore */
        }
    }

    function fetchAllPosts() {
        var key = getApiKey();

        if (!key) {
            return Promise.reject(new Error('missing-key'));
        }

        var base = getApiBase() + '/ghost/api/content/posts/';
        var page = 1;
        var pages = 1;
        var allPosts = [];

        function fetchPage() {
            var url = base
                + '?key=' + encodeURIComponent(key)
                + '&limit=100'
                + '&page=' + page
                + '&fields=title,slug,url,excerpt,html,custom_excerpt'
                + '&formats=html';

            return fetch(url).then(function (response) {
                if (!response.ok) {
                    throw new Error('fetch-failed');
                }

                return response.json();
            }).then(function (data) {
                allPosts = allPosts.concat(data.posts || []);
                pages = data.meta && data.meta.pagination ? data.meta.pagination.pages : 1;
                page += 1;

                if (page <= pages) {
                    return fetchPage();
                }

                return allPosts.map(normalizePost);
            });
        }

        return fetchPage();
    }

    function ensureIndex() {
        if (fuse) {
            return Promise.resolve();
        }

        if (isLoading) {
            return new Promise(function (resolve) {
                var timer = window.setInterval(function () {
                    if (fuse || !isLoading) {
                        window.clearInterval(timer);
                        resolve();
                    }
                }, 50);
            });
        }

        var cached = readCache();

        if (cached) {
            posts = cached;
            fuse = new Fuse(posts, {
                keys: [
                    { name: 'title', weight: 0.35 },
                    { name: 'excerpt', weight: 0.15 },
                    { name: 'plaintext', weight: 0.25 },
                    { name: 'code', weight: 0.25 }
                ],
                threshold: 0.35,
                ignoreLocation: true,
                minMatchCharLength: 2,
                includeScore: true
            });
            return Promise.resolve();
        }

        isLoading = true;
        setStatus(document.body.getAttribute('data-search-loading') || 'Loading...');

        return fetchAllPosts().then(function (items) {
            posts = items;
            writeCache(items);
            fuse = new Fuse(posts, {
                keys: [
                    { name: 'title', weight: 0.35 },
                    { name: 'excerpt', weight: 0.15 },
                    { name: 'plaintext', weight: 0.25 },
                    { name: 'code', weight: 0.25 }
                ],
                threshold: 0.35,
                ignoreLocation: true,
                minMatchCharLength: 2,
                includeScore: true
            });
        }).catch(function (error) {
            if (error && error.message === 'missing-key') {
                setStatus(document.body.getAttribute('data-search-no-key') || 'Search is not configured.');
            } else {
                setStatus(document.body.getAttribute('data-search-error') || 'Search failed.');
            }
        }).finally(function () {
            isLoading = false;
        });
    }

    function highlightMatch(text, query) {
        if (!text || !query) {
            return text;
        }

        var index = text.toLowerCase().indexOf(query.toLowerCase());

        if (index === -1) {
            return text;
        }

        return text.slice(0, index)
            + '<mark>'
            + text.slice(index, index + query.length)
            + '</mark>'
            + text.slice(index + query.length);
    }

    function getSnippet(item, query) {
        if (item.code && item.code.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
            var codeIndex = item.code.toLowerCase().indexOf(query.toLowerCase());
            var start = Math.max(0, codeIndex - 40);
            var snippet = item.code.slice(start, start + 120);
            return '<code class="dev-search-snippet-code">' + highlightMatch(snippet, query) + '</code>';
        }

        if (item.excerpt) {
            return highlightMatch(item.excerpt, query);
        }

        if (item.plaintext) {
            var plainIndex = item.plaintext.toLowerCase().indexOf(query.toLowerCase());
            var plainStart = Math.max(0, plainIndex - 40);
            return highlightMatch(item.plaintext.slice(plainStart, plainStart + 140), query);
        }

        return '';
    }

    function renderResults(query) {
        var list = getResultsEl();

        if (!list) {
            return;
        }

        list.innerHTML = '';

        if (!query || query.length < 2) {
            setStatus(document.body.getAttribute('data-search-hint') || '');
            return;
        }

        if (!fuse) {
            return;
        }

        var results = fuse.search(query).slice(0, 12);

        if (!results.length) {
            setStatus(document.body.getAttribute('data-search-empty') || 'No results found.');
            return;
        }

        setStatus('');

        results.forEach(function (result) {
            var item = result.item;
            var li = document.createElement('li');
            var link = document.createElement('a');
            link.href = item.url;
            link.className = 'dev-search-result';
            link.innerHTML = '<span class="dev-search-result-title">' + highlightMatch(item.title, query) + '</span>'
                + '<span class="dev-search-result-snippet">' + getSnippet(item, query) + '</span>';
            li.appendChild(link);
            list.appendChild(li);
        });
    }

    function openSearch() {
        var modal = getModal();
        var input = getInput();

        if (!modal) {
            return;
        }

        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dev-search-open');

        ensureIndex().then(function () {
            if (input) {
                input.focus();
                input.select();
            }
            renderResults(input ? input.value.trim() : '');
        });
    }

    function closeSearch() {
        var modal = getModal();
        var input = getInput();

        if (!modal) {
            return;
        }

        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('dev-search-open');

        if (input) {
            input.value = '';
        }

        renderResults('');
        setStatus('');
    }

    function bindEvents() {
        document.addEventListener('click', function (event) {
            if (event.target.closest('[data-custom-search]')) {
                event.preventDefault();
                openSearch();
            }

            if (event.target.closest('[data-search-close]')) {
                event.preventDefault();
                closeSearch();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && document.body.classList.contains('dev-search-open')) {
                closeSearch();
            }

            if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
                event.preventDefault();
                openSearch();
            }
        });

        document.addEventListener('input', function (event) {
            if (event.target.id === 'dev-search-input') {
                renderResults(event.target.value.trim());
            }
        });
    }

    if (typeof Fuse !== 'undefined') {
        bindEvents();
    }
})();
